'use client'; // Ensures this runs only on the client

import BlinkingSkeleton from '@/components/shared/blinking-skeleton/blinking-skeleton.component';
const ProfileSkeleton = () => {
    const newGalleryHeight =
        'calc(68.6vw + 20vw + 16px + 16px + 40px + 40px + 8px + 8px + 8px)';

    return (
        <div>
            <div className="md:hidden">
                <BlinkingSkeleton
                    height={newGalleryHeight}
                    minHeight={'50vh'}
                />
            </div>
            <div className="md:block hidden">
                <BlinkingSkeleton height={'50vh'} minHeight={'50vw'} />
            </div>
        </div>
    );
};

export default ProfileSkeleton;
